'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLoginUrl = exports.login = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _identity = require('@schibsted/account-sdk-browser/es5/identity');

var _monetization = require('@schibsted/account-sdk-browser/es5/monetization');

var _actions = require('./actions');

var actions = _interopRequireWildcard(_actions);

var _types = require('./types');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global window */
var identity = void 0;
var monetization = void 0;

var makeLoginState = function makeLoginState() {
    var state = Math.random().toString(16);
    window.localStorage.setItem('auth_state', state);
    window.localStorage.setItem('auth_origin', window.location.href);
    return state;
};

var login = exports.login = function login() {
    var state = makeLoginState();
    return identity.login({
        state: state
    });
};

var getLoginUrl = exports.getLoginUrl = function getLoginUrl() {
    var state = makeLoginState();
    return identity.loginUrl({
        state: state
    });
};

var hasAnyProduct = function hasAnyProduct(productIds, spId) {
    var lastError = void 0;
    return productIds.reduce(function (promise, productId) {
        return promise.then(function (response) {
            return response || monetization.hasProduct(productId, spId).catch(function (err) {
                lastError = err;
            });
        });
    }, _promise2.default.resolve()).then(function (response) {
        if (response) {
            return response;
        }
        return _promise2.default.reject(lastError);
    });
};

// config
var logoutRedirectUri = void 0;

exports.default = function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
        return function (action) {
            var nextAction = next(action);

            if (action.type === _types.SPID_START) {
                return dispatch(actions.init(action.payload)).then(function () {
                    return dispatch(actions.subscribeEvents());
                }).then(function () {
                    return dispatch(actions.hasSession());
                });
            }

            if (action.type === _types.SPID_INIT) {
                identity = new _identity.Identity(action.payload);
                if (action.payload.enableVarnishCookie) {
                    identity.enableVarnishCookie();
                }

                if (action.payload.productIds && action.payload.productIds.length) {
                    monetization = new _monetization.Monetization(action.payload);
                }

                if (action.payload.logoutRedirectUri) {
                    logoutRedirectUri = action.payload.logoutRedirectUri;
                }

                dispatch(actions.initComplete({
                    identity: identity,
                    monetization: monetization
                }));

                return _promise2.default.resolve({
                    identity: identity,
                    monetization: monetization
                });
            }

            if (action.type === _types.SPID_SUBSCRIBE_EVENTS) {
                if (!identity) {
                    return _promise2.default.reject(new Error('Spid Identity not initialized'));
                }

                identity.on('notLoggedin', function (data) {
                    return dispatch(actions.eventNotLoggedin(data));
                });
                identity.on('statusChange', function (data) {
                    return dispatch(actions.eventStatusChange(data));
                });
                identity.on('login', function (data) {
                    return dispatch(actions.eventLogin(data));
                });
                identity.on('logout', function (data) {
                    return dispatch(actions.eventLogout(data));
                });
                identity.on('userChange', function (data) {
                    return dispatch(actions.eventUserChange(data));
                });
                identity.on('sessionInit', function (data) {
                    return dispatch(actions.eventSessionInit(data));
                });
                identity.on('sessionChange', function (data) {
                    return dispatch(actions.eventSessionChange(data));
                });
                identity.on('visitor', function (data) {
                    return dispatch(actions.eventVisitor(data));
                });
                identity.on('error', function (data) {
                    return dispatch(actions.eventSessionError(data));
                });

                return _promise2.default.resolve();
            }

            if (action.type === _types.SPID_HAS_SESSION) {
                if (!identity) {
                    return _promise2.default.reject(new Error('Spid Identity not initialized'));
                }

                return identity.hasSession().then(function (response) {
                    dispatch(actions.hasSessionComplete(response));
                    return response;
                }, function (err) {
                    dispatch(actions.hasSessionError(err));
                });
            }

            if (action.type === _types.SPID_HAS_ANY_PRODUCT) {
                if (!monetization) {
                    return _promise2.default.reject(new Error('Spid Monetization not initialized'));
                }

                return _promise2.default.resolve().then(function () {
                    return identity.getSpId();
                }).then(function (spId) {
                    return hasAnyProduct(action.payload, spId);
                }).then(function (response) {
                    dispatch(actions.hasProductComplete(response));
                    return response;
                }, function (err) {
                    dispatch(actions.hasProductError(err));
                });
            }

            if (action.type === _types.SPID_HAS_PRODUCT) {
                if (!monetization) {
                    return _promise2.default.reject(new Error('Spid Monetization not initialized'));
                }

                return _promise2.default.resolve().then(function () {
                    return identity.getSpId();
                }).then(function (spId) {
                    return monetization.hasProduct(action.payload, spId);
                }).then(function (response) {
                    dispatch(actions.hasProductComplete(response));
                    return response;
                }, function (err) {
                    dispatch(actions.hasProductError(err));
                });
            }

            if (action.type === _types.SPID_HAS_SESSION_COMPLETE || action.type === _types.SPID_HAS_SESSION_ERROR) {
                if (!identity) {
                    return _promise2.default.reject(new Error('Spid Identity not initialized'));
                }

                if (action.type === _types.SPID_HAS_SESSION_COMPLETE) {
                    dispatch(actions.generateUrls({
                        logout: identity.logout,
                        getLoginUrl: getLoginUrl,
                        accountUrl: identity.accountUrl()
                    }));
                } else if (action.type === _types.SPID_HAS_SESSION_ERROR) {
                    dispatch(actions.generateUrls({
                        login: login,
                        getLoginUrl: getLoginUrl,
                        signupUrl: identity.signupFlowUrl()
                    }));
                }

                var _getState = getState(),
                    _getState$spid = _getState.spid;

                _getState$spid = _getState$spid === undefined ? {} : _getState$spid;
                var productId = _getState$spid.productId;


                if (action.type === _types.SPID_HAS_SESSION_COMPLETE && productId) {
                    dispatch(actions.hasProduct(productId));
                }

                return _promise2.default.resolve();
            }

            if (action.type === _types.SPID_LOGIN) {
                if (!identity) {
                    return _promise2.default.reject(new Error('Spid Identity not initialized'));
                }

                return login();
            }

            if (action.type === _types.SPID_LOGOUT) {
                if (!identity) {
                    return _promise2.default.reject(new Error('Spid Identity not initialized'));
                }

                var _ref2 = action.payload || {},
                    _ref2$redirectUri = _ref2.redirectUri,
                    redirectUri = _ref2$redirectUri === undefined ? logoutRedirectUri || window.location.href : _ref2$redirectUri;

                return identity.logout(redirectUri);
            }

            return nextAction;
        };
    };
};
//# sourceMappingURL=middleware.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/redux-spid/lib/cjs/middleware.js
 ** module id = 548
 ** module chunks = 1
 **/